import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <main className="pt-20 pb-16 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-12" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-500 cursor-pointer">{t('common:breadcrumb.home')}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800">{t('common:nav.about')}</span>
          </nav>

          <div className="max-w-4xl mx-auto">
            <section className="mb-20">
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-8">
                关于爆料网
              </h1>
              <div className="space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg">
                <p>
                  爆料网成立于2016年，是国内领先的娱乐八卦与网红黑料追踪平台。我们致力于为广大吃瓜群众提供第一手的娱乐圈内幕、明星八卦及独家爆料资讯，覆盖<strong>911爆料网</strong>、<strong>51爆料网</strong>、<strong>91爆料网</strong>等核心爆料入口。
                </p>
                <p>
                  经过近十年的深耕发展，爆料网已建立起完善的信息采集与核实体系。我们的编辑团队由资深娱乐记者和行业分析师组成，确保每一条爆料在发布前都经过严格的交叉验证，最大程度保证信息的真实性和可靠性。
                </p>
                <p>
                  我们的使命是让真相不再被掩埋，让每一个吃瓜群众都能第一时间掌握最劲爆的娱乐资讯。从明星婚姻内幕到综艺节目幕后操作，从网红人设崩塌到直播带货翻车——爆料网始终站在娱乐资讯的最前线。
                </p>
              </div>
            </section>

            <section className="mb-20">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
                品牌口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  { icon: 'ri-shield-check-line', title: '可信赖', desc: '每一条爆料均经过多方核实，确保信息真实可靠' },
                  { icon: 'ri-flashlight-line', title: '快速度', desc: '7×24小时全天候追踪，热点事件第一时间呈现' },
                  { icon: 'ri-group-line', title: '大社区', desc: '超过500万吃瓜群众共同参与，共建爆料生态' },
                ].map((item) => (
                  <div key={item.title} className="bg-background-100 rounded-xl p-6 md:p-8 text-center">
                    <div className="w-14 h-14 mx-auto flex items-center justify-center bg-primary-500/10 text-primary-500 rounded-full mb-4">
                      <i className={`${item.icon} text-2xl`}></i>
                    </div>
                    <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-20">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
                平台数据
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {[
                  { number: '500万+', label: '累计用户', icon: 'ri-user-star-line' },
                  { number: '15,000+', label: '爆料文章', icon: 'ri-article-line' },
                  { number: '300+', label: '日均更新', icon: 'ri-flashlight-line' },
                  { number: '98%', label: '信息准确率', icon: 'ri-shield-check-line' },
                ].map((stat) => (
                  <div key={stat.label} className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-10 h-10 mx-auto flex items-center justify-center bg-primary-500/10 text-primary-500 rounded-full mb-3">
                      <i className={`${stat.icon} text-lg`}></i>
                    </div>
                    <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">{stat.number}</div>
                    <div className="text-sm text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-20">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
                联系我们
              </h2>
              <div className="bg-background-100 rounded-xl p-6 md:p-10">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-accent-500/10 text-accent-500 rounded-lg">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">投稿邮箱</h3>
                      <p className="text-sm text-foreground-600">hello@baoliao91.cn</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-accent-500/10 text-accent-500 rounded-lg">
                      <i className="ri-wechat-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                      <p className="text-sm text-foreground-600">爆料网官方</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-accent-500/10 text-accent-500 rounded-lg">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
                      <p className="text-sm text-foreground-600">hello@baoliao91.cn</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
                常见问题
              </h2>
              <div className="space-y-4">
                {[
                  { q: '如何向爆料网投稿？', a: '您可以将爆料内容发送至我们的官方投稿邮箱 hello@baoliao91.cn，编辑团队将在24小时内审核并回复。所有投稿人均可选择匿名发布，我们严格保护爆料人隐私。' },
                  { q: '爆料网的信息是否真实可靠？', a: '我们坚持每一条爆料在发布前均经过多方交叉验证。我们的编辑团队由资深娱乐记者和行业分析师组成，确保信息质量。同时我们会在文章中明确标注信息来源和核实程度。' },
                  { q: '如何申请删除涉及个人的内容？', a: '如您认为本站内容涉及不实信息或侵犯了您的合法权益，请发送相关证明材料至 hello@baoliao91.cn，我们将在核实后依法依规进行处理。' },
                  { q: '爆料网的更新频率是怎样的？', a: '爆料网实行7×24小时全天候内容更新机制。每日早中晚三个时段定时推送最新爆料汇总，重大突发事件则实时跟进报道，确保您不错过任何重磅猛料。' },
                ].map((faq, idx) => (
                  <details key={idx} className="group bg-background-100 rounded-xl">
                    <summary className="flex items-center justify-between px-6 py-4 cursor-pointer font-heading font-semibold text-foreground-950 text-base md:text-lg">
                      {faq.q}
                      <i className="ri-arrow-down-s-line text-xl text-foreground-400 group-open:rotate-180 transition-transform duration-300"></i>
                    </summary>
                    <div className="px-6 pb-5 text-foreground-600 text-sm md:text-base leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                { '@type': 'Question', name: '如何向爆料网投稿？', acceptedAnswer: { '@type': 'Answer', text: '您可以将爆料内容发送至我们的官方投稿邮箱 hello@baoliao91.cn，编辑团队将在24小时内审核并回复。所有投稿人均可选择匿名发布，我们严格保护爆料人隐私。' } },
                { '@type': 'Question', name: '爆料网的信息是否真实可靠？', acceptedAnswer: { '@type': 'Answer', text: '我们坚持每一条爆料在发布前均经过多方交叉验证。我们的编辑团队由资深娱乐记者和行业分析师组成，确保信息质量。同时我们会在文章中明确标注信息来源和核实程度。' } },
                { '@type': 'Question', name: '如何申请删除涉及个人的内容？', acceptedAnswer: { '@type': 'Answer', text: '如您认为本站内容涉及不实信息或侵犯了您的合法权益，请发送相关证明材料至 hello@baoliao91.cn，我们将在核实后依法依规进行处理。' } },
                { '@type': 'Question', name: '爆料网的更新频率是怎样的？', acceptedAnswer: { '@type': 'Answer', text: '爆料网实行7×24小时全天候内容更新机制。每日早中晚三个时段定时推送最新爆料汇总，重大突发事件则实时跟进报道，确保您不错过任何重磅猛料。' } },
              ],
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'http://baoliao91.cn/' },
                { '@type': 'ListItem', position: 2, name: '关于我们' },
              ],
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: '爆料网',
              url: 'http://baoliao91.cn/',
              logo: 'http://baoliao91.cn/logo.png',
              description: '国内领先的娱乐八卦与网红黑料追踪平台，覆盖911爆料网、51爆料网、91爆料网等核心爆料入口。',
              foundingDate: '2016',
              sameAs: ['http://baoliao91.cn/'],
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: '投稿邮箱',
                email: 'hello@baoliao91.cn',
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: '关于我们 - 爆料网',
              description: '了解爆料网的品牌故事、平台数据、口碑评价与联系方式。',
              url: 'http://baoliao91.cn/about',
              isPartOf: {
                '@type': 'WebSite',
                name: '爆料网',
                url: 'http://baoliao91.cn/',
              },
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}